import { Link } from "react-router-dom";

const renderBlock = (item, index) => {
  switch (item.type) {
    case "paragraph":
      return (
        <p key={index} className="policy-block__paragraph">
          {item.content}
        </p>
      );

    case "titledList":
      return (
        <div key={index} className="policy-block__toc">
          <h2 className="policy-block__toc-title">{item.title}</h2>
          {item.subtitle && (
            <p className="policy-block__section-subtitle">{item.subtitle}</p>
          )}
          <ol className="policy-block__toc-list">
            {item.items.map((listItem, i) => (
              <li key={i} className="policy-block__toc-item">
                <a href={"#" + listItem}>
                  {i + 1} - {listItem}
                </a>
              </li>
            ))}
          </ol>
        </div>
      );

    case "titleSubtitle":
      return (
        <div
          key={index}
          className="policy-block__section"
          id={item.id ?? undefined}
        >
          <h2 className="policy-block__section-title">{item.title}</h2>
          <p className="policy-block__section-subtitle">{item.subtitle}</p>
        </div>
      );

    case "sectionNumbered":
      return (
        <div
          key={index}
          className="policy-block__section"
          id={item.id ?? undefined}
        >
          <h2 className="policy-block__section-title">{item.title}</h2>
          {item.subtitle && (
            <p className="policy-block__section-subtitle">{item.subtitle}</p>
          )}
          {item.subSections && item.subSections.length > 0 && (
            <div>
              {item.subSections.map((sub, subIndex) => (
                <div key={subIndex} className="policy-block__subsection">
                  {sub.title && (
                    <h3 className="policy-block__subsection-title">
                      {sub.title}
                    </h3>
                  )}
                  <p className="policy-block__subsection-subtitle">
                    {sub.subtitle}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      );

    case "relatedList":
      return (
        <div key={index} className="policy-block__related">
          <h2 className="policy-block__related-title">{item.title}</h2>
          <ol className="policy-block__related-list">
            {item.items.map((listItem) => (
              <li key={listItem.id} className="policy-block__related-item">
                <Link to={listItem.value}>
                  <span className="policy-block__related-dot" />
                  {listItem.label}
                </Link>
              </li>
            ))}
          </ol>
        </div>
      );

    default:
      return null;
  }
};

const PolicyContentRenderer = ({ content }) => {
  return <div>{content.map((item, index) => renderBlock(item, index))}</div>;
};

export default PolicyContentRenderer;
